/** Persian (Eastern Arabic–Indic) and Arabic-Indic digit sets for fa/ar UI. */

function langShort(lang) {
  return String(lang ?? 'en').split('-')[0].toLowerCase()
}

export function shouldUseEasternNumerals(lang) {
  const s = langShort(lang)
  return s === 'fa' || s === 'ar'
}

const WESTERN = '0123456789'
const PERSIAN = '۰۱۲۳۴۵۶۷۸۹'
const ARABIC_INDIC = '٠١٢٣٤٥٦٧٨٩'

function digitMap(lang) {
  const s = langShort(lang)
  if (s === 'fa') return PERSIAN
  if (s === 'ar') return ARABIC_INDIC
  return WESTERN
}

/** Replace ASCII digits 0–9 in a string (fa → Persian digits, ar → Arabic-Indic). */
export function localizeDigits(str, lang) {
  if (str == null) return str
  const s = String(str)
  if (!shouldUseEasternNumerals(lang)) return s
  const map = digitMap(lang)
  return s.replace(/[0-9]/g, (ch) => map[Number(ch)] ?? ch)
}

export function formatUiInteger(value, lang) {
  const n = Number(value)
  if (!Number.isFinite(n)) return localizeDigits(String(value), lang)
  return localizeDigits(String(Math.trunc(n)), lang)
}

/** Whole-number percent, e.g. 42 → ۴۲٪ in fa */
export function formatUiPercentWhole(value, lang) {
  const n = Math.round(Number(value))
  if (!Number.isFinite(n)) return `${localizeDigits(String(value), lang)}%`
  return `${formatUiInteger(n, lang)}%`
}

/** mm:ss for game timer HUD (localized digits for fa/ar). */
export function formatUiClockMmSs(totalSeconds, lang) {
  const sec = Math.max(0, Math.floor(Number(totalSeconds) || 0))
  const m = Math.floor(sec / 60)
  const s = sec % 60
  const secPadded = String(s).padStart(2, '0')
  return `${formatUiInteger(m, lang)}:${localizeDigits(secPadded, lang)}`
}

export function formatUiDateTime(isoOrDate, timeZone, lang) {
  const d = isoOrDate instanceof Date ? isoOrDate : new Date(isoOrDate)
  if (Number.isNaN(d.getTime())) return ''
  const s = langShort(lang)
  const locale = s === 'fa' ? 'fa-IR' : s === 'ar' ? 'ar' : s === 'nl' ? 'nl-NL' : 'en-US'
  const opts = {
    timeZone: timeZone || undefined,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }
  try {
    return d.toLocaleString(locale, opts)
  } catch {
    return d.toLocaleString(locale, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    })
  }
}
